import { Create, Edit, List, SimpleForm, TextInput, required, Datagrid, TextField, EditButton } from 'react-admin';
import { default as icon } from '@mui/icons-material/TrendingUp';

const list = () =>
    <List>
		<Datagrid>
			<TextField source="name" />
			<TextField source="description" />
			<EditButton />
		</Datagrid>
    </List>;

const FormFields = (
	<SimpleForm>
		<TextInput source="name" validate={required()} />
		<TextInput source="description" />
		<TextInput source="body" label="Outcome" multiline />
	</SimpleForm>
);

const edit = () => <Edit>{FormFields}</Edit>;
const create = () => <Create>{FormFields}</Create>;

export const Outcome = { list, edit, create, icon };

export default Outcome;